import { createFileRoute } from '@tanstack/react-router';
import AdminSettings from '../../pages/admin/Settings';
import { settingsQueryOptions } from '../../lib/queryOptions';

export const Route = createFileRoute('/admin/settings')({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(settingsQueryOptions()),
  component: AdminSettings,
});
